import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=b48d0044&scoped=true"
import script from "./Users.ts?vue&type=script&lang=ts&external"
export * from "./Users.ts?vue&type=script&lang=ts&external"
import style0 from "./Users.vue?vue&type=style&index=0&id=b48d0044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d0044",
  null
  
)

export default component.exports